import { LegalDocumentPage } from "./legal-document-page"

export function PrivacyPolicyPage() {
  return <LegalDocumentPage kind="privacy" />
}
